// Previously an inline <script> in index.html. Moved into the bundle so it
// loads under `script-src 'self'` without needing 'unsafe-inline' (AVA-25477).
// Must stay the first import in index.tsx: some deps expect `global` to
// exist at module-evaluation time, before their own imports run.
if (typeof window !== 'undefined') {
  window.global = window;
}
